import { render } from "./CurrencyTable.vue?vue&type=template&id=7f3bc0a6&scoped=true"
import script from "./CurrencyTable.vue?vue&type=script&lang=js"
export * from "./CurrencyTable.vue?vue&type=script&lang=js"

import "./CurrencyTable.vue?vue&type=style&index=0&id=7f3bc0a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f3bc0a6"]])

export default __exports__